import { Box, Button, CircularProgress } from "@mui/material";

type FloatingSaveButtonProps = {
  show: boolean;
  onSave: () => void;
  isSaving?: boolean;
};

export const FloatingSaveButton = ({ show, onSave, isSaving = false }: FloatingSaveButtonProps) => {
  if (!show) return null;

  return (
    <Box
      sx={{
        position: "fixed",
        bottom: 24,
        right: 32,
        zIndex: 1000,
      }}
    >
      <Button
        variant="contained"
        size="large"
        onClick={onSave}
        disabled={isSaving}
        startIcon={isSaving ? <CircularProgress size={20} color="inherit" /> : undefined}
      >
        {isSaving ? "Saving..." : "Save Changes"}
      </Button>
    </Box>
  );
};

